<template>
  <div>
    <b-row class="mb-1">
      <b-col>
        <h2>
          <b-badge variant="info">Présence vidéo</b-badge>
        </h2>
      </b-col>
    </b-row>

    <b-row
      v-if="meeting.allowed_modalities.video"
      class="mb-4 sticky-multiselect-add-participants-video align-self-start"
    >
      <b-col>
        <label>
          <h4>
            Ajouter un contact avec pouvoir
            <font-awesome-icon id="popover-presence-2" icon="info-circle" size="1x" class="mx-2" />
            <b-popover target="popover-presence-2" triggers="hover" placement="top">
              Gérer l'attribution de pouvoirs pour les participants qui sont connectés depuis
              l'espace personnel&nbsp;:
              <u class="text-primary">https://participant.domeo-ag.com</u>
            </b-popover>
          </h4>
        </label>

        <v-multiselect
          :show-labels="false"
          :options="assignContactPouvoirOptions"
          :max-height="300"
          placeholder="Tapez pour rechercher"
          track-by="identifier"
          label="search"
          open-direction="bottom"
          @select="onSelectContact"
          @open="showAssignContactPouvoirMultiselect = true"
          @close="showAssignContactPouvoirMultiselect = false"
        >
          <template slot="option" slot-scope="props">
            <div class="select-option-main">
              {{ props.option.name }}
            </div>
          </template>
          <template slot="beforeList" class="p-2">
            <div class="p-3" style="cursor: pointer;" @click="openModalCreateContact">
              <div><font-awesome-icon icon="plus-circle" /> Ajouter une nouvelle contact.</div>
            </div>
          </template>
          <span slot="noResult" class="mx-2">
            Oops! Aucun élément trouvé. Pensez à modifier la requête de recherche.
          </span>
        </v-multiselect>
      </b-col>
    </b-row>

    <!-- Modal Create Contact -->
    <b-modal id="modal-create-contact-video" size="lg" hide-footer centered>
      <modalCreateContact
        :building-id="meeting.building_id"
        @closeModal="closeModalCreateContact"
        @setContact="setContact"
      />
    </b-modal>
    <!-- Modal Ask Building Owner -->
    <b-modal id="modal-ask-building-owner-video" size="lg" hide-footer centered>
      <modalAskBuildingOwner
        :options="assignBuildingOwnerOptions"
        @setMandate="setMandate"
        @onOpenSelect="showAskBuildingOwnerMultiselect = true"
        @onCloseSelect="showAskBuildingOwnerMultiselect = false"
      />
    </b-modal>

    <b-row class="justify-content-center">
      <b-col cols="12">
        <!-- Main presence table -->
        <appVideoPresenceTable class="mandates-table mb-5" :presence-mandates="presenceMandates" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MandateMW from "@/middlewares/Mandate";
import MandateORM from "@/store/orm-axios/models/Mandate";

import meetingDetailsMixin from "@/mixins/meeting-details";
import mandatePresenceMixin from "@/mixins/mandate-presence";
import minutesMixin from "@/mixins/minutes";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";

import modalCreateContact from "@/components/modals/create-contact/CreateContact";
import modalAskBuildingOwner from "@/components/modals/create-contact/AskBuildingOwner";

export default {
  components: {
    modalCreateContact,
    modalAskBuildingOwner,
    appVideoPresenceTable: () =>
      import("@/components/meetings/meeting-presence/VideoPresenceTable"),
  },
  mixins: [
    mandatePresenceMixin,
    meetingDetailsMixin,
    minutesMixin,
    meetingPresenceSelectOptionsMixins,
  ],
  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedContact: null,
      showAssignContactPouvoirMultiselect: false,
      assignContactPouvoirOptions: [],
      showAskBuildingOwnerMultiselect: false,
      assignBuildingOwnerOptions: [],
    };
  },
  watch: {
    showAssignContactPouvoirMultiselect(val) {
      if (val) {
        this.assignContactPouvoirOptions = this.getCsNotShowUpNotIntendToOpts();
      } else {
        this.assignContactPouvoirOptions = [];
      }
    },
    showAskBuildingOwnerMultiselect(val) {
      if (val) {
        this.assignBuildingOwnerOptions = this.getBOsNotShowedUpOrRepresentedOpts();
      } else {
        this.assignBuildingOwnerOptions = [];
      }
    },
  },
  methods: {
    openModalCreateContact() {
      this.$bvModal.show("modal-create-contact-video");
    },
    closeModalCreateContact() {
      this.$bvModal.hide("modal-create-contact-video");
    },
    onSelectContact(selectedContact) {
      this.selectedContact = selectedContact;
      this.$bvModal.show("modal-ask-building-owner-video");
    },
    async ASSIGN_MANDATE(selectedContact, buildingOwnerId) {
      try {
        this.$store.state.showLoaderOverlay = true;

        var assignedMandate = MandateORM.query()
          .where("meeting_id", this.meeting.id)
          .where("building_owner_id", buildingOwnerId)
          .first();

        if (assignedMandate.presence_status == this.mandatePresenceStatuses.correspondence) {
          await this.deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(assignedMandate);
        }

        var self = this;
        MandateORM.update({
          where: assignedMandate.id,
          data(item) {
            item.representant_contact_id = selectedContact.id;
            item.representant_owner_id = null;
            item.presence_status = self.mandatePresenceStatuses.pouvoir_by_video_not_present_yet;
          },
        }).then(async updatedMandate => {
          await MandateMW.PUT(updatedMandate, false);

          self.$store.state.showLoaderOverlay = false;
        });
      } catch (err) {
        console.error(err);
        this.$store.state.showLoaderOverlay = false;
        this.$swal(this.alertError());
      }
    },
    setContact(contact) {
      this.selectedContact = {
        type: "contact",
        id: contact.id,
      };
      this.$bvModal.hide("modal-create-contact-video");
      this.$bvModal.show("modal-ask-building-owner-video");
    },
    setMandate(buildingOwnerId) {
      this.$bvModal.hide("modal-ask-building-owner-video");
      this.ASSIGN_MANDATE(this.selectedContact, buildingOwnerId);
    },
  },
};
</script>
